// Decides what a signed-in user sees while their account still has
// password_change_required set (every account created by a guest checkout does).
//
//  'password'     -> the set-password screen, instead of any other page
//  'confirmation' -> the purchase confirmation page, shown on its own. A new student
//                    who has just paid sees "You're enrolled!" first; its
//                    "set your password" button leads to any other route, which lands
//                    back on the 'password' gate. Nothing else is reachable.
//  'none'         -> no gate
export function passwordGateAction(user, pathname) {
  if (!user || !user.password_change_required) return 'none';
  return pathname === '/confirmation' ? 'confirmation' : 'password';
}
